import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationEquipmentListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setEquipmentList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationEquipmentListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      dispatch(
        setLoading({
          key: "isOnboardEquipmentListInProgress",
          status: true,
        }),
      );

      await axios
        .get(`${CONFIGURATION_APIS?.EQUIPMENT_LIST?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationEquipmentListResponse>) => {
          if (res.data.status === true) {
            dispatch(
              setEquipmentList({
                data: res.data.data,
              }),
            );
          } else {
            toast.error("Error while fetching equipment list.");
          }
          dispatch(
            setLoading({
              key: "isOnboardEquipmentListInProgress",
              status: false,
            }),
          );
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      // Handle errors
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching equipment list.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + error.message);
      }
      dispatch(
        setLoading({
          key: "isOnboardEquipmentListInProgress",
          status: false,
        }),
      );
    }
  }, [dispatch, configuration]);

  return execute;
};
